import type {QuestionAnswer, Questionnaire} from '@common/models'

export type PreQuestionnaireAnswers = Record<
  string,
  {value?: string; choices?: string[]}
>

export const isRequiredPreqComplete = (
  questionnaire: Questionnaire,
  preqAnswers: PreQuestionnaireAnswers,
): boolean => {
  const questions = questionnaire.questions || []
  const requiredQs = questions.filter((q) => !q.isOptional)
  if (requiredQs.length === 0) return true
  return requiredQs.every((q) => {
    const ans = preqAnswers[q.id]
    const hasValue = !!ans?.value && ans.value.trim().length > 0
    const hasChoice = Array.isArray(ans?.choices) && ans.choices.length > 0
    return hasValue || hasChoice
  })
}

export const toPreQuestionnaireLiteralAnswers = (
  questionnaire: Questionnaire,
  preqAnswers: PreQuestionnaireAnswers,
): QuestionAnswer[] => {
  const questions = questionnaire.questions || []
  const questionById = new Map(questions.map((q) => [q.id, q]))

  return Object.entries(preqAnswers).flatMap(([questionId, ans]) => {
    const q = questionById.get(questionId)
    const questionTitle = q?.title
    let answerText: string | undefined
    if (ans?.value && ans.value.trim().length > 0) {
      answerText = ans.value.trim()
    } else if (Array.isArray(ans?.choices) && ans.choices.length > 0) {
      const labels = (ans.choices || [])
        .map((cid) => q?.choices?.find((c) => c.id === cid)?.label)
        .filter((label): label is string => !!label)
      answerText = labels.join(', ')
    }
    if (!questionTitle || !answerText) return []
    return [{question: questionTitle, answer: answerText}]
  })
}
